import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useCallback, useEffect, useState, useMemo } from 'react';
import { useGetBuyersQuery } from '~/features/user/model/api/users-api';
import { useAssignAccountMutation } from '~/features/accounts/model/api/accounts-api';
import { useSnackbar } from 'notistack';
import { IModalAssignProps } from '~/shared/types/types';

const format = (data: any) => Array.isArray(data) ? data : Object.values(data || {});

export const ModalAssign: React.FC<IModalAssignProps> = ({ open, handleClose, ids }) => {
  const [user, setUser] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const { data = [] } = useGetBuyersQuery(undefined, { skip: !open });
  const [assign] = useAssignAccountMutation();

  const users = useMemo(() => {
    const result = format(data?.data || []);
    return [...result].sort((a, b) => {
      const nameA = a?.name?.toLowerCase?.() || '';
      const nameB = b?.name?.toLowerCase?.() || '';
      return nameA.localeCompare(nameB);
    });
  }, [data]);


  const handleChange = (event: SelectChangeEvent) => {
    setUser(event.target.value as string);
  };

  const submit = useCallback(() => {
    Promise.all(
      ids.map((item) => assign({ account_id: item.id, user_id: user }))
    ).then(() => {
      enqueueSnackbar('Все аккаунты успешно назначены байеру', { type: 'success' });
      setUser('');
      handleClose();
    }).catch((e) => {
      enqueueSnackbar(e.message, { type: 'error' });
    });
  }, [assign, ids, user, handleClose, enqueueSnackbar]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description">
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          pt: 2,
          px: 4,
          pb: 3,
          width: 400
        }}>
          <h3 id="child-modal-title">Выберите байера</h3>

          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={user}
              label="Роль"
              onChange={handleChange}
            >
              {
                users.map((item) => (
                  <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                ))
              }
            </Select>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '12px',
                pt: '12px',
                alignContent: 'end',
              }}>
              <Button variant="outlined" sx={{ flex: 1 }} onClick={handleClose}>
                Отменить
              </Button>
              <Button
                disabled={!user}
                color="primary"
                sx={{ flex: 1 }}
                onClick={submit}
                variant="contained">
                Сохранить
              </Button>
            </Box>
          </FormControl>
        </Box>
      </Modal >
    </>
  );
};
